var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"safe-manager"}},[_c('div',{staticClass:"wrapper"},[_c('mainHeader',{staticClass:"mainHeader"}),_vm._v(" "),_vm._l((_vm.images),function(value,index){return _c('img',{key:index,attrs:{"src":value}})}),_vm._v(" "),_c('mainFooter',{staticClass:"mainFooter"})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14e0508c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/product-testing.vue
// module id = null
// module chunks = 